<template>
  <div id="app">
    <div
      class="main"
      :style="{ 'padding-bottom': mainPadding, zoom: fontSize }"
    >
      <ModalIdle />
      <top-line-partial v-if="showLayout"></top-line-partial>
      <header-partial v-if="showLayout"></header-partial>
      <secondary-header-partial v-if="showLayout"></secondary-header-partial>
      <router-view />
      <footer-partial v-if="showLayout"></footer-partial>
      <div class="d-none d-lg-block">
        <button
          v-show="visible"
          @click="scrollToTop"
          class="btn btn-primary btn-to-top"
        >
          {{ $t("goToTheTop") }}
        </button>
      </div>

      <div class="d-block d-lg-none">
        <button
          v-show="visible"
          @click="scrollToTop"
          class="left_back-to-top_btn btn btn-primary btn-to-top"
        >
          <span class="icon-chevrons-up"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import HeaderPartial from "@/partials/HeaderPartial.vue";
import TopLinePartial from "@/partials/TopLinePartial.vue";
import FooterPartial from "@/partials/FooterPartial.vue";
import ModalIdle from "@/components/ModalIdle.vue";
import SecondaryHeaderPartial from "./partials/SecondaryHeaderPartial.vue";
import * as userService from "./services/user-service";
import axios from "axios";
import { useIdle } from "./useIdle";
import { useRoute } from "vue-router";
const store = useStore();
const route = useRoute();

const mainPadding = ref("360px !important");

const fontSize = computed(() => store.state.fontSize);
const showLayout = computed(() => store.state.showLayout);

const { isIdle } = useIdle(7200);
const visible = ref(false);

watch(isIdle, (val) => {
  if (val) {
    onIdle();
  }
});

watch(route, () => {
  updateMainPadding();
});

function handleScroll() {
  visible.value = window.scrollY > 200; // pojavi se posle 200px
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function updateMainPadding() {
  const list = ["pdf"];
  const isChildComponentActive = route.matched.some((r) =>
    list.includes(r.name)
  );

  mainPadding.value = isChildComponentActive
    ? "0 !important"
    : "360px !important";
}

function onIdle() {
  console.log("idle istekao");
  axios.post(`${window.env.VUE_APP_API_PENG_DEV}prins/logout`);
  store.dispatch("setShowModalIdle", true);
}

function getStoredLanguage() {
  return localStorage.getItem("language") || "srp";
}

onMounted(async () => {
  if (window.env.CHAT_ENABLE) {
    const scriptLangElement = document.createElement("script");
    if (getStoredLanguage() === "en") {
      scriptLangElement.innerHTML =
        "var lz_data = { overwrite: false, language: 'en' }";
    } else {
      scriptLangElement.innerHTML =
        "var lz_data = { overwrite: false, language: 'srp' }";
    }
    document.body.appendChild(scriptLangElement);

    const chatUrl = window.env.CHAT_URL;
    const scriptElement = document.createElement("script");
    scriptElement.type = "text/javascript";
    scriptElement.id = window.env.CHAT_ID;
    scriptElement.defer = true;
    scriptElement.src = chatUrl;
    document.body.appendChild(scriptElement);
  }

  await axios
    .post(`${window.env.VUE_APP_API_PENG_DEV}prins/info`)
    .then((response) => {
      if (response.status === 204) {
        store.dispatch("resetUserInfo");
      } else {
        const userData = response.data;
        store.dispatch("setUserInfo", userData);
        userService.setUser(userData);
      }
    })
    .catch((err) => console.error(err));

  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style>
html {
  padding: 0 !important;
  scroll-behavior: smooth;
}

::v-deep .vbt-table-tools {
  display: none;
}

::v-deep #livezilla_wm {
  top: -25px !important;
}

::v-deep .lz_chat_unselectable,
.lz_overlay_wm_button,
.NotPrintableArea,
.lz_overlay_wm_sh_act,
.lz_anim_slide_in {
  top: -25px !important;
}

::v-deep #lz_overlay_wm .lz_overlay_wm_sh_act {
  top: -25px !important;
}

::v-deep .lz_overlay_wm {
  bottom: 50px !important;
}

::v-deep #lz_overlay_wm {
  margin-bottom: 50px;
}

::v-deep .lz_overlay_wm {
  bottom: 50px !important;
}

::v-deep .at-share-dock.atss {
  position: relative !important;
}

.at-share-dock.atss {
  position: relative !important;
}

::v-deep .atss {
  position: relative !important;
}

/* .atss {
    position: relative!important;
} */
@media (max-width: 800px) {
  #news_modal_17832___BV_modal_title_ {
    font-size: 12px !important;
    text-align: center;
    font-weight: 600;
  }

  .modal-title {
    font-size: 12px !important;
    text-align: center;
    font-weight: 600;
  }

  .mb-2 .mb-md-0 {
    font-size: 12px !important;
    text-align: center;
    font-weight: 600;
  }
}
#lz_overlay_chat {
  margin: 0px 0px 0px 0px !important;
}
</style>
